// extracted by mini-css-extract-plugin
export default {"wrapper":"Prescriptions_wrapper__sHSAd","title":"Prescriptions_title__v7UBT","header":"Prescriptions_header__w5+Us"};